import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';

// Shared-link sessions are anonymous (no currentUser, no workspace), so tag
// them explicitly; the share token itself is a credential and must never be
// sent to Sentry.
export function useShareSentryTags() {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = pathname.match(/\/(reports|narratives|custom-dashboards)\/([^/]+)\/share/);
    Sentry.setTag('session_type', 'share');
    Sentry.setTag('share_resource_type', match?.[1]);
    Sentry.setTag('share_resource_id', match?.[2]);

    return () => {
      Sentry.setTag('session_type', undefined);
      Sentry.setTag('share_resource_type', undefined);
      Sentry.setTag('share_resource_id', undefined);
    };
  }, [pathname]);
}
